import {
  listStandaloneLayeredMedia,
  createLayeredMedia,
  deleteLayeredMedia,
  duplicateLayeredMedia,
  updateLayeredMedia,
  type StandaloneLayeredMedia,
} from '@/modules/kinema/layeredMediaService';

export const standaloneProjectService = {
  list: (organizationId: number): Promise<StandaloneLayeredMedia[]> =>
    listStandaloneLayeredMedia(organizationId),

  create: (input: {
    name: string;
    organization_id: number;
    data: any;
    type?: 'video' | 'image';
  }) =>
    createLayeredMedia({
      ...input,
      type: input.type ?? 'video',
      is_standalone: true,
    }),

  rename: (id: number, name: string) => updateLayeredMedia(id, { name }),

  delete: (id: number) => deleteLayeredMedia(id),

  duplicate: (id: number) => duplicateLayeredMedia(id),
};
